export default "__VITE_ASSET__BALpLBFH__"